module.exports = __webpack_public_path__ + "static/media/LogoDiaDasMães_Preta.bf29902d.png";